<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12 md:col-12">
      <div class="card card-w-title">
        <HeaderBar createButton="true" @new-event="dialog.create = true" title="تگ" />
        <Divider type="dashed" />
        <!-- Table Section Begin -->
        <div v-if="!!tags.length && !loading.page">
          <DataTable ref="dt" :value="tags" dataKey="id" class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn" responsiveLayout="scroll">
            <Column field="title" header="عنوان" headerStyle="width:14%; min-width:10rem;">
              <template #body="slotProps">
                <span class="p-column-title">عنوان</span>
                {{ slotProps.data.title }}
              </template>
            </Column>
            <Column header="آیکون" headerStyle="width:14%; min-width:10rem;">
              <template #body="slotProps">
                <span class="p-column-title">تصویر</span>
                <img :src="'https://api.koome.net/' + slotProps.data.icon" width="30" />
              </template>
            </Column>
            <Column header="عملیات" headerStyle="min-width:10rem;">
              <template #body="slotProps">
                <Button icon="pi pi-pencil" v-tooltip.top="'ویرایش'" class="p-button-rounded p-button-success ml-2" @click="editCollection(slotProps.data)" />
                <Button icon="pi pi-trash" v-tooltip.top="'حذف'" class="p-button-rounded p-button-warning mt-2" @click="confirmDeleteCollection(slotProps.data)" />
                <Button @click="changeActiveStatus(slotProps.data)" type="button" :icon="`pi pi-${slotProps.data.isActive ? 'check' : 'times'}`" v-tooltip.top="'وضعیت'" :class="`p-button-rounded p-button-${slotProps.data.isActive ? 'success' : 'danger'} mr-2`"></Button>
              </template>
            </Column>
          </DataTable>
          <Paginator :rows="pageSize" :totalRecords="totalCount" @page="changePaging($event)"></Paginator>
        </div>
        <div v-if="!tags.length && !loading.page" class="w-full text-center my-3">
          <InlineMessage>موردی وجود ندارد</InlineMessage>
        </div>
        <Loading v-if="loading.page" />
        <!-- Table Section End -->
        <!-- Edit Dialog Section Begin -->
        <Dialog @hide="(editPicture = null), (editIcon = null)" v-model:visible="dialog['edit']" :style="{ width: '450px' }" header="ویرایش" :modal="true" class="p-fluid">
          <!-- Picture edit section begin -->
          <div class="text-center">
            <h6>تصویر</h6>
            <div v-if="selected.picture">
              <img role="presentation" :alt="selected.picture" :src="'https://api.koome.net/' + selected.picture" class="w-20rem h-10rem border-1 border-round-3xl" />
              <div class="field remove-picture">
                <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="selected.picture = null" />
              </div>
            </div>
            <div v-else class="mb-6">
              <div v-if="editPicture != null" class="field">
                <img role="presentation" :alt="editPicture.name" :src="imageConvertBlob(editPicture)" class="w-20rem h-10rem border-1 border-round-3xl" />
                <div class="field remove-picture">
                  <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="editPicture = null" />
                </div>
              </div>
              <div v-else>
                <label for="pictureUploaderId" class="w-full justify-content-center cursor-pointer">
                  <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                </label>
                <input id="pictureUploaderId" @change="onUpload($event, 'edit', 'picture')" accept="image/png, image/jpeg" type="file" hidden />
              </div>
            </div>
          </div>
          <!-- Picture edit section end -->
          <!-- Icon edit section begin -->
          <div class="text-center">
            <h6>آیکون</h6>
            <div v-if="selected.icon">
              <img role="presentation" :alt="selected.icon" :src="'https://api.koome.net/' + selected.icon" class="w-20rem h-10rem border-1 border-round-3xl" />
              <div class="field remove-picture">
                <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="selected.icon = null" />
              </div>
            </div>
            <div v-else class="mb-4">
              <div v-if="editIcon != null" class="field">
                <img role="presentation" :alt="editIcon.name" :src="imageConvertBlob(editIcon)" class="w-20rem h-10rem border-1 border-round-3xl" />
                <div class="field remove-picture">
                  <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="editIcon = null" />
                </div>
              </div>
              <div v-else>
                <label for="iconUploaderId" class="w-full justify-content-center cursor-pointer">
                  <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                </label>
                <input id="iconUploaderId" @change="onUpload($event, 'edit', 'icon')" accept="image/png, image/jpeg" type="file" hidden />
              </div>
            </div>
          </div>
          <!-- Icon edit section end -->
          <div class="field">
            <label for="name">عنوان</label>
            <InputText
              id="name"
              v-model.trim="selected.title"
              @blur="v$.selected.title.$touch"
              @input="v$.selected.title.$touch"
              required="true"
              autofocus
              :class="
                ({ 'p-invalid': submitted && !selected.title },
                {
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.selected.title.$invalid,
                })
              "
            />
            <small v-if="v$.selected.title.$invalid" ref="password_error_message" class="text-red-500">
              {{ v$.selected.title.required.$message }}
            </small>
            <!-- <small class="p-invalid" v-if="submitted && !selected.title">Name is required.</small> -->
          </div>
          <template #footer>
            <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
            <Button label="ویرایش" icon="pi pi-check" class="p-button-text" @click="updateCollection" />
          </template>
        </Dialog>
        <!-- Edit Dialog Section Ended -->
        <!-- Create Dialog Section Begin -->
        <Dialog @hide="(picture = null), (icon = null)" v-model:visible="dialog['create']" :style="{ width: '600px' }" header="ایجاد تگ" :modal="true" class="p-fluid">
          <div class="formgrid grid col-12 text-center mb-4">
            <div class="w-full">
              <h5>آپلود تصویر</h5>
              <div v-if="!picture">
                <label for="uploaderId" class="w-full justify-content-center cursor-pointer">
                  <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                </label>
                <input id="uploaderId" @change="onUpload($event, 'add', 'picture')" accept="image/png, image/jpeg" type="file" hidden />
              </div>
              <div class="text-center relative" v-else>
                <img role="presentation" :alt="picture.name" :src="imageConvertBlob(picture)" class="w-20rem h-10rem border-1 border-round-3xl" />
                <div class="field remove-picture">
                  <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="picture = null" />
                </div>
              </div>
            </div>
          </div>
          <div class="formgrid grid col-12 text-center">
            <div class="w-full">
              <h6>آپلود آیکون</h6>
              <div v-if="!icon">
                <label for="uploaderId" class="w-full justify-content-center cursor-pointer">
                  <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                </label>
                <input id="uploaderId" @change="onUpload($event, 'add', 'icon')" accept="image/svg+xml" type="file" hidden />
              </div>
              <div class="text-center relative" v-else>
                <img role="presentation" :alt="icon.name" :src="imageConvertBlob(icon)" class="w-20rem h-10rem border-1 border-round-3xl" />
                <div class="field remove-picture">
                  <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="icon = null" />
                </div>
              </div>
            </div>
          </div>
          <div class="field mt-4">
            <span class="p-float-label">
              <InputText
                id="catTitle"
                type="text"
                v-model="collection.title"
                @blur="v$.collection.title.$touch"
                @input="v$.collection.title.$touch"
                :class="{
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.collection.title.$error,
                }"
              />
              <label for="catTitle">عنوان</label>
            </span>
            <small v-if="v$.collection.title.$invalid && v$.collection.title.$dirty" ref="password_error_message" class="text-red-500">
              {{ v$.collection.title.required.$message }}
            </small>
          </div>
          <template #footer>
            <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="(dialog['create'] = false), (picture = null), (icon = null)" />
            <Button type="submit" class="p-button-text" label="ایجاد" icon="pi pi-check" @click="createTag" :loading="loading[create]" />
          </template>
        </Dialog>
        <!-- Create Dialog Section Ended -->
        <!-- Delete Dialog Section Begin -->
        <Dialog v-model:visible="dialog['delete']" :style="{ width: '450px' }" header="تایید" :modal="true">
          <div class="flex flex-column align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
            <span v-if="selected" class="mt-3">آیا مطمئن هستید؟</span>
          </div>
          <template #footer>
            <div class="text-center">
              <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="dialog['delete'] = false" />
              <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="removeCollection" />
            </div>
          </template>
        </Dialog>
        <!-- Delete Dialog Section Ended -->
      </div>
    </div>
  </div>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  name: "featureCollectionPage",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      collection: {
        title: "",
      },
      svgUploaded: "",
      loading: {
        page: false,
        create: false,
        update: false,
        remove: false,
      },
      tags: [],
      selected: {},
      dialog: {
        edit: false,
        delete: false,
        create: false,
      },
      submitted: false,
      picture: null,
      editPicture: null,
      icon: null,
      editIcon: null,
      pageSize: 10,
      totalCount: 10,
    };
  },
  validations() {
    return {
      selected: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
      collection: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
    };
  },
  methods: {
    //**************************** Api methods begin ****************************//
    async getTagsList(page = 1) {
      this.loading.page = true;
      const { status, data } = await this.axios({ method: "get", url: `Tag/GetAll?TitleQuery=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.totalCount = data.totalCount;
      this.tags = [...data.data];
      this.loading.page = false;
    },
    async createTag() {
      const config = { header: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("picture", this.picture);
      formData.append("icon", this.icon);
      formData.append("title", this.collection.title);
      const { status, data } = await this.axios({ method: "post", url: "Tag/Create", data: formData, config });
      status == 200 || status == 201 ? this.getTagsList() : false;
      this.showToast(status);
      this.dialog["create"] = false;
      this.collection.title = "";
      this.picture = this.icon = null;
    },
    async removeCollection() {
      const { status, data } = await this.axios({ method: "delete", url: `Tag/Delete/${this.selected.id}` });
      status === 200 ? (this.selected = {}) : "";
      this.showToast(status);
      this.getTagsList();
      this.dialog["delete"] = false;
    },
    async updateCollection() {
      const config = { header: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("NewPicture", this.editPicture !== null ? this.editPicture : null);
      formData.append("NewIcon", this.editIcon !== null ? this.editIcon : null);
      formData.append("title", this.selected.title);
      const { status, data } = await this.axios({ method: "put", url: `Tag/Update/${this.selected.id}`, data: formData, config });
      if (status == 200) {
        this.selected = {};
        this.editPicture = null;
        this.editIcon = null;
        this.hideDialog();
      }
      this.getTagsList();
      this.showToast(status);
    },
    changePaging(e) {
      this.getTagsList(++e.page);
    },
    async changeActiveStatus(selected) {
      const { status, data } = await this.axios({ method: "patch", url: `tag/changeActiveStatus/${selected.id}` });
      this.showToast(status);
      (status == 200 || status == 201) &&
        this.tags.map((_category) => {
          _category.id == selected.id ? (_category.isActive = !selected.isActive) : false;
        });
    },
    //**************************** Api methods end ****************************//
    onUpload(event, status, type) {
      let target = event.target;
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        target.files[0]["binary"] = reader.result;
      });
      reader.readAsBinaryString(target.files[0]);
      if (type == "picture") {
        if (event.target.files[0].type === "image/jpeg" || event.target.files[0].type === "image/png") {
          this.editPicture = null;
          status == "add" ? (this.picture = event.target.files[0]) : (this.editPicture = event.target.files[0]);
        } else {
          this.$toast.add({ severity: "error", summary: "خطا", detail: "فرمت وارد شده باید jpeg یا png باشد", life: 3000 });
        }
      }
      if (type == "icon") {
        if (event.target.files[0].type === "image/svg+xml" || event.target.files[0].type === "image/svg+xml") {
          this.editIcon = null;
          status == "add" ? (this.icon = event.target.files[0]) : (this.editIcon = event.target.files[0]);
        } else {
          this.$toast.add({ severity: "error", summary: "خطا", detail: "فرمت وارد شده باید jpeg یا png باشد", life: 3000 });
        }
      }
    },
    editCollection(selected) {
      this.selected = { ...selected };
      this.dialog["edit"] = true;
    },
    confirmDeleteCollection(selected) {
      this.selected = selected;
      this.dialog["delete"] = true;
    },
    hideDialog() {
      this.dialog["edit"] = false;
      this.submitted = false;
      this.editPicture = null;
      this.editIcon = null;
    },
    imageConvertBlob(picture) {
      return URL.createObjectURL(picture);
    },
  },
  mounted() {
    this.getTagsList();
  },
};
</script>

<style lang="scss">
.file-uploader {
  width: auto;
  margin: 0;
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-items: center;
  -align: bottom;
  text-averticallign: center;
  overflow: hidden;
  position: relative;
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;

  &:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 black;
    outline: 0 none;
    outline-offset: 0;
  }
}
</style>
